<template>
  <div>
    <Spinner v-if="loading" />
    <div v-else>
        <div class="mt-8 flex flex-col items-center">
            <h1 class="text-3xl text-center text-ihh-dark-salmon font-ihh-bold">{{ blog.title }}</h1>
            <div class="text-ihh-form-label">Posted by {{ blog.author }} on {{ formatDate(new Date(blog.dateCreated)) }}</div>
        </div>


        <div class="flex justify-center pt-0 p-8 pb-0">
            <div v-html="blog.content" class="prose max-w-none content" />
        </div>

        <!-- Socials -->
        <div class="flex space-x-1 w-full justify-center my-24 items-center">
            <a href="https://www.facebook.com/InHisHandsBirthSupply" target="_blank">
                <img src="/images/ihh-facebook0129.svg" class="w-10 h-10 py-[7px] px-[10px]" />
            </a>
            <a href="https://www.pinterest.com/inhishandsbirth/" target="_blank">
                <img src="/images/ihh-pinterest0129.svg" class="w-10 h-10 py-[7px] px-[7px]" />
            </a>
            <a href="https://www.instagram.com/inhishandsbirth/?hl=en" target="_blank" class="">
                <img src="/images/ihh-instagram0129.svg" class="w-10 h-10 p-[7px]" />
            </a>
            <a href="https://x.com/inhishandsbirth" target="_blank">
                <img src="/images/ihh-twitter0129.svg" class="w-10 h-10 p-[7px]" />
            </a>
            <button @click="openMailApp" class="w-10 h-10 p-[7px]">
                <img src="/images/ihh-envelope-48.png" alt="filled-message">
            </button>
            <button @click="printPage" class="w-10 h-10 p-[7px]">
                <img src="/images/ihh-printer-60.png" alt="filled-message">
            </button>
        </div>
    </div>

  </div>
</template>

<script>
import Mango from '../../helpers/mango'
export default {
  name: "CustomBirthKitBlogPost",
  inject: ['store'],
  data() {
    return {
        loading: true,
        slug: null,
        blog: null
    };
  },

  methods: {
    async fetchBlog() {
        console.log("fetching blog...")
        const slug = this.$route.params.slug;
        const search = { search: { slug }, limit: 1 }
        const blogs = await Mango.blogs(search);
        console.log("blog", blogs)
        if (blogs) {
            this.blog = blogs[0];
            this.loading = false;
        }
        return null;
    },
    formatDate(date) {
        const day = date.getDate();
        const month = date.toLocaleString('default', { month: 'short' });
        const year = date.getFullYear();

        const ordinalSuffix = (day) => {
            if (day > 3 && day < 21) return 'th';
            switch (day % 10) {
            case 1: return 'st';
            case 2: return 'nd';
            case 3: return 'rd';
            default: return 'th';
            }
        };

        return `${day}${ordinalSuffix(day)} ${month} ${year}`;
    },
    openMailApp() {
        let subject;
        console.log("Mail app user: ", this.store.user?.id)
        if (this.store?.user?.id) {
            console.log(this.store.user.firstName, this.store.user.lastName)
            subject = `${this.store?.user?.firstName} ${this.store?.user?.lastName} - ${this.store?.user?.email}`;
        } else {
            subject = ""
        }
      const mailtoLink = `mailto:help@inhishands.com?subject=${subject}`;
      window.location.href = mailtoLink;
    },
    printPage() {
        window.print();
    }
  },

  mounted() {
    this.slug = this.$route.params.slug;

    console.log("Calling fetch blog")
    this.fetchBlog();
  },

  computed: {
  }
};
</script>

<style>
/* set a max width for content class of 10 rem */
.content {
    max-width: 50rem;
}

.content a {
    color: #e59789;
    text-decoration: underline;
}

.content h3 span {
    color: #736980;
}

.content img {
    display: block;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 0;
    max-width: 58.333333%;
    height: auto;
}
</style>
